import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { IconButton, Paper } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

const AudioPlayer = ({ audioUrl }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#CDDFE7', width: '100%', maxWidth: '300px' }}>
      <ReactPlayer
        url={audioUrl}
        controls={true}
        width="100%"
        height="30px"
        style={{ outline: 'none' }}
      />
    </div>
  );
};

export default AudioPlayer;